import ODAS from '@/utils/api/odas';

const getBaseUrl = (forClientId) => {
  if (forClientId) {
    return 'api/agency_clients/' + forClientId + '/uploaded_documents';
  } else {
    return 'api/uploaded_documents';
  }
};

const UploadedDocuments = {
  getUploadedDocuments: (forClientId, locale) => {
    return ODAS.get(getBaseUrl(forClientId), { locale });
  },

  getUploadedDocument: (id, forClientId) => {
    return ODAS.get(getBaseUrl(forClientId) + '/' + id);
  },

  getUploadedDocumentBlob: (id, forClientId) => {
    return ODAS.get(getBaseUrl(forClientId) + '/' + id + '/blob');
  },

  getUploadedDocumentAccess: (id, scope) => {
    return ODAS.get(getBaseUrl() + '/' + id + '/access', { scope: scope });
  },

  removeSharedUploadedDocument: (id, email) => {
    return ODAS.delete(getBaseUrl() + '/' + id + '/access', { email: email });
  },

  shareUploadedDocument: (id, email) => {
    return ODAS.post(getBaseUrl() + '/' + id + '/access', { email: email });
  },

  createUploadedDocument: (data, forClientId) => {
    return ODAS.post(getBaseUrl(forClientId), data);
  },

  updateUploadedDocument: (id, data, forClientId) => {
    return ODAS.put(getBaseUrl(forClientId) + '/' + id, data);
  },

  deleteUploadedDocument: (id, forClientId) => {
    return ODAS.delete(getBaseUrl(forClientId) + '/' + id);
  },

  removeAccessToDocument: (id, forClientId) => {
    return ODAS.delete(getBaseUrl(forClientId) + '/' + id + '/remove_access');
  },

  updateDocumentConsent: (params, agencyClientId) => {
    return ODAS.put(getBaseUrl(agencyClientId) + '/consent', params);
  }
};

export default UploadedDocuments;
